import React, { useEffect, useState, useContext, useMemo } from "react";
import { UserOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { SocketContext } from "../../context/socketContext";
import { Collapse, Input, message, Tooltip, Select } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import { mergeVisitorProfile, computePastChats, computePastVisits, visitorProfileMatches } from "../../helpers/visitorPastStats";

export default function SideBarDrawer({ currentActiveVisitorData }) {
    const { Socket } = useContext(SocketContext);
    const pastChatDetails = useSelector((state) => state.PastChat.data);

    const { TextArea } = Input;
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [Tags, setTags] = useState([]);
    const [phone, setPhone] = useState("");
    const [visitorNotes, setVisitorNotes] = useState("");
    const [textCopied, settextCopied] = useState(false);
    useEffect(() => {
        if (currentActiveVisitorData !== null) {
            setName(currentActiveVisitorData?.name);
            setEmail(currentActiveVisitorData?.email);
            setPhone(currentActiveVisitorData?.phone);
            setVisitorNotes(currentActiveVisitorData?.visitor_notes);
            setTags(currentActiveVisitorData?.tags);
        }
    }, [currentActiveVisitorData?.name,
    currentActiveVisitorData?.email,
    currentActiveVisitorData?.phone,
    currentActiveVisitorData?.visitor_notes]);
    const updateClientInfo = () => {
        Socket.emit("updateVisitorInfo", {
            name: name, email: email, phone: phone, visitor_notes: visitorNotes, tags: Tags,
            visitorId: currentActiveVisitorData?.unique_id,
            websiteToken: currentActiveVisitorData?.websiteToken
        });
    };

    // heloo
    const { Panel } = Collapse;
    /** Visitor path: collapsed by default; Current page: expanded */
    const [open, setOpen] = useState([]);
    const [openView, setOpenView] = useState(["1"]);
    const handleSubmit = (keys) => {
        if (keys === undefined || keys === null) {
            setOpen([]);
            return;
        }
        setOpen(Array.isArray(keys) ? keys : [keys]);
    };

    const handleSubmitView = (keys) => {
        if (keys === undefined || keys === null) {
            setOpenView([]);
            return;
        }
        setOpenView(Array.isArray(keys) ? keys : [keys]);
    };

    const copyToClipboard = (url) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                settextCopied(true);
            })
            .catch(err => {
                settextCopied(false);
            });
    };

    const handleChange = (newTags) => {
        const maxTagLength = 15
        // Check if any tag exceeds the max length
        const invalidTag = newTags.find(tag => tag.length > maxTagLength);
        if (invalidTag) {
            message.error(`Tag "${invalidTag}" is too long. Max ${maxTagLength} characters.`);
            return;
        }
        setTags(newTags);
    };


    const visitorProfile = useMemo(() => {
        const fetched = visitorProfileMatches(pastChatDetails, currentActiveVisitorData?.unique_id)
            ? pastChatDetails
            : null;
        return mergeVisitorProfile(currentActiveVisitorData, fetched) ?? currentActiveVisitorData;
    }, [currentActiveVisitorData, pastChatDetails]);

    const pastVisits = computePastVisits(visitorProfile);
    const pastChats = computePastChats(visitorProfile);

    return (
        <div className="chatVisitorDrawer__sidebarScroll currentHistory">
            <div className="visitorInfo chatVisitorDrawer__visitorInfo">
                {/* Visitor profile: name, email, phone, notes */}
                <div className="chatVisitorDrawer__sidebarCard">
                    <div className="visitorName chatVisitorDrawer__visitorNameRow">
                        <UserOutlined className="anticon-user2" />
                        <div className="chatVisitorDrawer__visitorFields">
                            <Input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                name="name"
                                placeholder="Add name"
                                onBlur={() => updateClientInfo()}
                                maxLength={20}
                            />
                            <Input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                name="email"
                                placeholder="Add email"
                                onBlur={() => updateClientInfo()}
                            />
                        </div>
                    </div>
                    <Input
                        type="number"
                        value={phone}
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 15) {
                                setPhone(inputValue);
                            }
                        }}
                        name="phone"
                        placeholder="Add phone number"
                        onBlur={() => updateClientInfo()}
                        maxLength={15}
                    />
                    <TextArea
                        rows={4}
                        value={visitorNotes}
                        name="visitor_notes"
                        onChange={(e) => setVisitorNotes(e.target.value)}
                        placeholder="Add visitor notes"
                        onBlur={() => updateClientInfo()}
                        maxLength={6000}
                        style={{
                            height: 90,
                            resize: "none",
                        }}
                    />
                </div>

                <div className="chatVisitorDrawer__sidebarCard chatVisitorDrawer__tagsCard">
                    <div className="chatVisitorDrawer__fieldLabel">
                        <span>Tags</span>
                        <Tooltip title="Tags are visible to your team on this chat">
                            <QuestionCircleOutlined className="chatVisitorDrawer__helpIcon" />
                        </Tooltip>
                    </div>
                    <Select
                        mode="tags"
                        className="chatVisitorDrawer__tagsSelect"
                        placeholder="Add chat tags"
                        onChange={handleChange}
                        tokenSeparators={[',']}
                        maxLength={15}
                        value={Tags}
                        onBlur={() => updateClientInfo()}
                    />
                </div>

                <div className="chatVisitorDrawer__statsRow">
                    <div className="chatVisitorDrawer__statTile">
                        <h4 style={{ margin: 0 }}>{pastVisits}</h4>
                        <span>Past visits</span>
                    </div>
                    <div className="chatVisitorDrawer__statTile">
                        <strong>{pastChats}</strong>
                        <span>Past chats</span>
                    </div>
                    <div className="chatVisitorDrawer__statTile">
                        <h4 style={{ margin: 0 }}>{moment(currentActiveVisitorData?.start_time).fromNow(true)}</h4>
                        <span>Time on site</span>
                    </div>
                </div>

                <div className="chatVisitorDrawer__sidebarCard chatVisitorDrawer__collapseCard">
                    <Collapse style={{ marginBottom: 0 }} activeKey={openView} onChange={handleSubmitView}>
                        <Panel header="Current page" key="1">
                            <Tooltip placement="left" title={currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.url}>
                                <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", alignItems: "flex-start", overflow: "hidden" }}>
                                    <p style={{ margin: 0 }}>{moment.utc(currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.time).format("MM-DD-YY - HH:mm")}</p>
                                    <a
                                        style={{ marginBottom: 5 }}
                                        href={currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.url}
                                        target="_blank"
                                    >
                                        {currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.url?.length > 35 ? `${currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.url.slice(0, 35)}...` : currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.url}
                                    </a>
                                    {/* <a style={{ marginBottom: 5 }} href={currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.url} target="_blank" >{currentActiveVisitorData?.url?.[currentActiveVisitorData?.url?.length - 1]?.url}</a> */}
                                </div>
                            </Tooltip>
                        </Panel>
                    </Collapse>

                    <Collapse activeKey={open} onChange={handleSubmit}>
                        <Panel header="Visitor path" key="1">
                            {currentActiveVisitorData?.url?.slice().reverse().map((urls, index) => {
                                return <Tooltip key={index} placement="left" title={`${urls?.url} - (${moment.utc(urls?.time).format("MM,DD,YY - HH:mm")})`}>
                                    <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", alignItems: "flex-start", overflow: "hidden" }}>
                                        <p style={{ margin: 0 }}>{moment.utc(urls?.time).format("MM-DD-YY - HH:mm")}</p>
                                        <a
                                            style={{ marginBottom: 5 }}
                                            href={urls?.url}
                                            target="_blank"
                                        >
                                            {urls?.url.length > 35 ? `${urls?.url.slice(0, 35)}...` : urls?.url}
                                        </a>
                                    </div>
                                </Tooltip>
                            })}
                            {/* {result?.map((i, index) => {

                                    let newString = i?.url?.length > 40 ? i?.url?.substring(0, 80 / 2) + '...' : i?.url;

                                    return (
                                        <Tooltip placement="top" title={`${i?.url} - (${i?.count})`}>
                                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", overflow: "hidden" }}>
                                                <a href={i?.url} target="_blank" key={index}>{newString}</a>&nbsp; &nbsp; <p>({i?.count})</p>
                                            </div>
                                        </Tooltip>
                                    );
                                })} */}
                            {/* <p>{clientInfo?.brand?.brandname}</p> */}
                        </Panel>
                    </Collapse>
                </div>

                <div className="visitorGeoInfo chatVisitorDrawer__sidebarCard chatVisitorDrawer__geoCard">
                    <div className="listFlex">
                        <p>Referrer Url: </p>
                        <Tooltip placement="top" title={textCopied ? "Copied" : "Copy"}>
                            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => copyToClipboard(currentActiveVisitorData?.referrerUrl)} id="url"> {currentActiveVisitorData?.referrerUrl}</span>
                        </Tooltip>
                    </div>
                    <div className="listFlex">
                        <p>Location :</p>
                        <span>{currentActiveVisitorData?.location?.city && `${currentActiveVisitorData?.location?.city},`}{currentActiveVisitorData?.location?.region && `${currentActiveVisitorData?.location?.region},`}{currentActiveVisitorData?.location?.country}</span>
                    </div>
                    <div className="listFlex">
                        <p>Browser :</p>
                        <span>{currentActiveVisitorData?.browser?.name}</span>
                    </div>
                    <div className="listFlex">
                        <p>Platform :</p>
                        <span>{currentActiveVisitorData?.platform}</span>
                    </div>
                    <div className="listFlex">
                        <p>Device :</p>
                        <span>
                            {currentActiveVisitorData
                                ? currentActiveVisitorData?.isMobileDevice
                                    ? "Mobile"
                                    : currentActiveVisitorData?.isTabletdDevice
                                        ? "Tablet"
                                        : "PC"
                                : "-"}
                        </span>
                    </div>
                    <div className="listFlex">
                        <p>IP Address :</p>
                        <span>{currentActiveVisitorData?.ip}</span>
                    </div>
                    <p>User agent :</p>
                    <span>{currentActiveVisitorData?.userAgent}</span>
                </div>
            </div>
        </div>
    )
}
